import Vue from 'vue';
import VueRouter from 'vue-router';
import adminsRoutes from './Admins/routes';
import dashboardRoutes from './Dashboard/routes';
import departmentRoutes from './Departments/routes';
import logRoutes from './Log/routes';
import projectRoutes from './Projects/routes';
import workerRoutes from './Workers/routes';
import settingsRoutes from './Settings/routes';
import journalRoutes from './Journal/routes';
import RootRedirect from './RootRedirect';

Vue.use(VueRouter);

const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: RootRedirect,
    },
    adminsRoutes,
    dashboardRoutes,
    departmentRoutes,
    logRoutes,
    projectRoutes,
    workerRoutes,
    settingsRoutes,
    journalRoutes,
  ],
});

export default router;
